import { PropsWithChildren, useCallback, useState } from 'react';

import { type Match } from '@services/MatchesService';

import { ChatSafetyContext, ChatSafetyState } from './useChatSafetyContext';

export const ChatSafetyContextProvider = ({ children }: PropsWithChildren) => {
  const [chatSafetyState, setChatSafetyState] = useState<ChatSafetyState>({});

  const chatVisibleBySafetySelector = useCallback(
    (profile?: Match) => {
      return (
        !profile?.blocked_by_me &&
        !profile?.blocked_me &&
        !chatSafetyState.isConfirmBlocking &&
        !chatSafetyState.isDialog &&
        !chatSafetyState.isDeleting
      );
    },
    [chatSafetyState],
  );

  const updateChatSafetyState = useCallback(
    <T extends keyof ChatSafetyState>(key: T, value: boolean | 'toggle') => {
      setChatSafetyState((prev) => ({
        ...prev,
        [key]: value === 'toggle' ? !prev[key] : value,
      }));
    },
    [setChatSafetyState],
  );

  return (
    <ChatSafetyContext.Provider
      value={{
        updateChatSafetyState,
        chatVisibleBySafetySelector,
        chatSafetyState,
      }}
    >
      {children}
    </ChatSafetyContext.Provider>
  );
};
